export default __webpack_public_path__ + "static/media/diamond.0b16b9df.png";